import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { useUpdateAvailable } from '@/hooks/useUpdateAvailable';
import { Button } from '@/components/ui/Button';

/**
 * Story 107.3 — non-blocking toast that surfaces when the deployed
 * version is newer than the bundle running in this tab. Renders
 * nothing when versions match. Refresh action is one click.
 */
export function UpdateBanner() {
  const { t } = useTranslation();
  const { available, refresh } = useUpdateAvailable();
  if (!available) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[60] flex max-w-sm items-center gap-3 rounded-lg border border-primary/40 bg-card px-4 py-3 shadow-lg">
      <Sparkles className="h-4 w-4 text-primary" />
      <div className="flex-1 text-sm">
        <div className="font-medium">{t('updateBanner.title')}</div>
        <div className="text-xs text-muted-foreground">
          {t('updateBanner.subtitle')}
        </div>
      </div>
      <Button size="sm" onClick={refresh}>
        {t('updateBanner.refresh')}
      </Button>
    </div>
  );
}
